// Change images on hover or click
$('.js-change-image > *').on('click mouseover', function() {
  const $this = $(this);
  const index = $this.index();

  $this
    .addClass('is-visible')
    .siblings()
    .removeClass('is-visible');

  $this
    .closest('.js-holder')
    .find('.js-images img')
    .eq(index)
    .addClass('is-visible')
    .siblings()
    .removeClass('is-visible');

  $this
    .closest('.js-holder')
    .find('.js-content > *')
    .eq(index)
    .addClass('is-visible')
    .siblings()
    .removeClass('is-visible');
});



// WEBPACK FOOTER //
// ./../src/assets/js/change-image.js